<template>
  <div id="commentTree">
    <div v-for="data in treeData">
      <a-comment>
        <div slot="content">
          <div class="commentList" :class="showBorder ? 'border_top' : ''">
            <div></div>
            <div class="commentItem">
              <a-avatar icon="user" :size="45" :src="getImageUrl(data.tree.commenterImg)" v-if="showHead"/>
              <div v-else style="width: 50px; height: 50px;"></div>
              <div class="commentItemRight">
                <div class="commentInfoRow">
                  <div class="commentAuthor">
                    <span class="userName">
                      {{data.tree.createName}}
                    </span>
                  <span v-if="data.tree.toUserName != '~'">
                    <span>
                      {{$t('news.editPage.reply')}}
                    </span>
                    <span class="userName">
                      {{data.tree.toUserName}}
                    </span>
                  </span>
                  </div>
                  <span class="commentTime">{{data.tree.createTime | dayjs}}</span>
                  <div style="width: 20px;" @click="toggleInnerCommentInput(data.tree,true)">
                    <pt-icon type="icon-pinglun" class="commentIcon"></pt-icon>
                  </div>
                </div>
                <div class="commentContentDiv">
                  <i class="contentArrow"></i>
                  <div class="commentContent">{{data.tree.content}}</div>
                </div>
                <div class="commentInputSmall" v-if="data.tree.visible">
                  <a-form :form="form">
                    <a-form-item>
                      <a-textarea :rows="3" :placeholder="$t('news.editPage.commentTip')" v-decorator="['content',{rules:[]}]"></a-textarea>
                    </a-form-item>
                  </a-form>
                  <div class="commentBtnRow">
                    <a-button type="primary" :loading="saveLoading" @click.stop="submit(data.tree)">
                      {{$t('baseVO.confirm')}}
                    </a-button>
                    <a-button style="margin-right:10px;"  @click.stop="toggleInnerCommentInput(data.tree,false)">
                      {{$t('baseVO.cacel')}}
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a-comment>
      <comment-tree :showBorder="false" :showHead="false" :treeData="data.children" v-if="data.children && data.children.length > 0" @submit="submitFromChild"></comment-tree>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'commentTree',
    props: {
      treeData: {
        type: Array,
        default: () => []
      },
      showHead:{
        type: Boolean,
        default: true
      },
      showBorder:{
        type: Boolean,
        default : true
      },
    },
    data() {
      return {
        form: this.$form.createForm(this,{})
      }
    },
    mounted() {
    },
    methods: {
      getImageUrl(headimg){
        return this.$util.getFileUrl(headimg)
      },
      submit(tree){
        this.$emit('submit', tree, this.form.getFieldsValue())
      },
      submitFromChild(tree, form){
        this.$emit('submit', tree, form)
      },
      toggleInnerCommentInput(item,visible){
        item.visible = visible;
      }
    }
  }
</script>

<style scoped lang="less">

  .commentDiv{
    .commentBtnRow{
      display: flex;
      flex-direction: row-reverse;
      margin-top: 10px;
    }
    .commentBtn{
      height: 30px;
      padding: 0 10px;
      background: #FAFBFC;
      border-radius: 4px;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      span{
        margin-left: 2px;
        font-size: 12px;
        color: #666666;
      }
    }
    .commentInput{
      padding: 15px 20px;
    }
    .border_top{
      border-top: 1px solid #E1E1E1;
    }
    .commentList{
      .commentTitle{
        font-size: 12px;
        color: #666666;
      }
      .commentItem{
        display: flex;
        flex-direction: row;
        margin-top: 6px;
      }
      .commentItemRight{
        flex: 1;
        .commentInputSmall{
          padding: 10px 0;
        }
      }
      .commentInfoRow{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-top: 15px;
        .commentAuthor{
          width: 200px;
          margin-left: 4px;
          font-size: 14px;
          color: #4D4D4D;
          .userName{
            font-size: 14px;
            color: #188BE3;
          }
        }
        .commentTime{
          font-size: 14px;
          color: #909090;
        }
      }
      .commentContentDiv{
        position: relative;
        margin-top: 10px;
        .contentArrow{
          position: absolute;
          border: 6px solid rgba(0,0,0,0);
          height: 0;
          line-height: 0;
          font-size: 0;
          top: -12px;
          left: 0;
          border-bottom-color:rgba(244,245,248,0.6);
          border-left-color:rgba(244,245,248,0.6);
        }
        .commentContent{
          padding: 10px;
          background: rgba(244,245,248,0.6);
          border-radius: 0 0 5px 5px;
          font-size: 12px;
          color: #323232;
          letter-spacing: 0;
          text-align: justify;
          line-height: 24px;
        }
      }
      .innerCommentDiv{
        background: rgba(248,249,251,0.62);
        border-radius: 0 0 4px 4px;
        padding: 14px 14px 14px 20px;
        .innerCommentRow{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
        .innerCommentRowLeft{
          font-size: 14px;
          color: #323232;
          line-height: 20px;
          word-break: break-word;
          .innerAuthor{
            font-size: 14px;
            color: #188BE3;
          }
          .innerCommentLabel{
            font-size: 14px;
            color: #333333;
            margin: 0 10px;
          }
          .innerCommentInfo{
            font-size: 14px;
            color: #323232;
            line-height: 16px;
          }
        }
        .innerCommentRowRight{
          cursor: pointer;
          height: 20px;
          width: 20px;
          margin-left: 10px;
        }
      }
    }
  }
</style>